
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {StackHolderPaymentsOutput, StartFreeComplexPackageInput, StartFreeComplexPackageOutput, PurchaseComplexPackageInput, PurchaseComplexPackageOutput, CustomizeComplexPackageInput, CustomizeComplexPackageOutput, CalculateComplexPackageInput, CalculateComplexPackageOutput, PayInvoiceInput, PayInvoiceOutput, ApplyDiscountCodeInput, ApplyDiscountCodeOutput, CalculateInvoicePaymentDetailsInput, CalculateInvoicePaymentDetailsOutput, InvoiceInput, InvoiceOutput, ManagerCancelInvoiceInput, ManagerCancelInvoiceOutput, UseManualDeliveryUserProductsInput, UseManualDeliveryUserProductsOutput, UseOnDemandUserProductInput, UseOnDemandUserProductOutput, PrepareComplexPackageInput, RateUserProductInput, RateUserProductOutput, SkipRateUserProductsInput, SkipRateUserProductsOutput, FeedbackRateInput, FeedbackRateOutput, ComplexPackagesOutput, TariffComplexPackagesOutput, InvoicesOutput, WalletBalanceOutput, ProductFeedbackOutput, RatesOutput, ProductsUsageOutput, ApplicantActiveProductsOutput, ManagerCancellingInvoiceOutput, ComplexPackageCounselorOutput } from '../../types/store';

export default  {
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.store}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.store}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },
 
    
    callback(data : any, urlParams : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.store}/Payment/Callback/${urlParams.paymentId}`,data, options);
    },
 
    
    callbackGet(queryParams : string, urlParams : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.store}/Payment/CallbackGet/${urlParams.paymentId}${queryParams || ""}`,undefined, options);
    },
 
    
    stackHolderPayments(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< StackHolderPaymentsOutput >("GET",`${config.apiUrl.store}/StackHolderQuery/StackHolderPayments${queryParams || ""}`,undefined, options);
    },
 
    
    startFreeComplexPackage(data : StartFreeComplexPackageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< StartFreeComplexPackageOutput, StartFreeComplexPackageInput >("POST",`${config.apiUrl.store}/StoreCommand/StartFreeComplexPackage`,data, options);
    },
 
    
    purchaseComplexPackage(data : PurchaseComplexPackageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< PurchaseComplexPackageOutput, PurchaseComplexPackageInput >("POST",`${config.apiUrl.store}/StoreCommand/PurchaseComplexPackage`,data, options);
    },
 
    
    customizeComplexPackage(data : CustomizeComplexPackageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CustomizeComplexPackageOutput, CustomizeComplexPackageInput >("POST",`${config.apiUrl.store}/StoreCommand/CustomizeComplexPackage`,data, options);
    },
 
    
    calculateComplexPackage(data : CalculateComplexPackageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CalculateComplexPackageOutput, CalculateComplexPackageInput >("POST",`${config.apiUrl.store}/StoreCommand/CalculateComplexPackage`,data, options);
    },
 
    
    payInvoice(data : PayInvoiceInput, options?: AxiosRequestOptions) { 
        return axiosRequest< PayInvoiceOutput, PayInvoiceInput >("POST",`${config.apiUrl.store}/StoreCommand/PayInvoice`,data, options);
    },
 
    
    applyDiscountCode(data : ApplyDiscountCodeInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ApplyDiscountCodeOutput, ApplyDiscountCodeInput >("POST",`${config.apiUrl.store}/StoreCommand/ApplyDiscountCode`,data, options);
    },
 
    
    calculateInvoicePaymentDetails(data : CalculateInvoicePaymentDetailsInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CalculateInvoicePaymentDetailsOutput, CalculateInvoicePaymentDetailsInput >("POST",`${config.apiUrl.store}/StoreCommand/CalculateInvoicePaymentDetails`,data, options);
    },
 
    
    invoice(data : InvoiceInput, options?: AxiosRequestOptions) { 
        return axiosRequest< InvoiceOutput, InvoiceInput >("POST",`${config.apiUrl.store}/StoreCommand/Invoice`,data, options);
    },
 
    
    managerCancelInvoice(data : ManagerCancelInvoiceInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ManagerCancelInvoiceOutput, ManagerCancelInvoiceInput >("POST",`${config.apiUrl.store}/StoreCommand/ManagerCancelInvoice`,data, options);
    },
 
    
    useManualDeliveryUserProducts(data : UseManualDeliveryUserProductsInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UseManualDeliveryUserProductsOutput, UseManualDeliveryUserProductsInput >("POST",`${config.apiUrl.store}/StoreCommand/UseManualDeliveryUserProducts`,data, options);
    },
 
    
    useOnDemandUserProduct(data : UseOnDemandUserProductInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UseOnDemandUserProductOutput, UseOnDemandUserProductInput >("POST",`${config.apiUrl.store}/StoreCommand/UseOnDemandUserProduct`,data, options);
    },
 
    
    prepareComplexPackage(data : PrepareComplexPackageInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CustomizeComplexPackageOutput, PrepareComplexPackageInput >("POST",`${config.apiUrl.store}/StoreCommand/PrepareComplexPackage`,data, options);
    },
 
    
    rateUserProduct(data : RateUserProductInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RateUserProductOutput, RateUserProductInput >("POST",`${config.apiUrl.store}/StoreCommand/RateUserProduct`,data, options);
    },
 
    
    skipRateUserProducts(data : SkipRateUserProductsInput, options?: AxiosRequestOptions) { 
        return axiosRequest< SkipRateUserProductsOutput, SkipRateUserProductsInput >("POST",`${config.apiUrl.store}/StoreCommand/SkipRateUserProducts`,data, options);
    },
 
    
    feedbackRate(data : FeedbackRateInput, options?: AxiosRequestOptions) { 
        return axiosRequest< FeedbackRateOutput, FeedbackRateInput >("POST",`${config.apiUrl.store}/StoreCommand/FeedbackRate`,data, options);
    },
 
    
    complexPackages(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ComplexPackagesOutput >("GET",`${config.apiUrl.store}/StoreQuery/ComplexPackages${queryParams || ""}`,undefined, options);
    },
 
    
    tariffComplexPackages(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< TariffComplexPackagesOutput >("GET",`${config.apiUrl.store}/StoreQuery/TariffComplexPackages${queryParams || ""}`,undefined, options);
    },
 
    
    invoices(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< InvoicesOutput >("GET",`${config.apiUrl.store}/StoreQuery/Invoices${queryParams || ""}`,undefined, options);
    },
 
    
    walletBalance(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< WalletBalanceOutput >("GET",`${config.apiUrl.store}/StoreQuery/WalletBalance${queryParams || ""}`,undefined, options);
    },
 
    
    productFeedBack(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ProductFeedbackOutput >("GET",`${config.apiUrl.store}/StoreQuery/ProductFeedBack${queryParams || ""}`,undefined, options);
    },
 
    
    rates(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< RatesOutput >("GET",`${config.apiUrl.store}/StoreQuery/Rates${queryParams || ""}`,undefined, options);
    },
 
    
    productsUsage(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ProductsUsageOutput >("GET",`${config.apiUrl.store}/StoreQuery/ProductsUsage${queryParams || ""}`,undefined, options);
    },
 
    
    applicantActiveProducts(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ApplicantActiveProductsOutput >("GET",`${config.apiUrl.store}/StoreQuery/ApplicantActiveProducts${queryParams || ""}`,undefined, options);
    },
 
    
    managerCancellingInvoice(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ManagerCancellingInvoiceOutput >("GET",`${config.apiUrl.store}/StoreQuery/ManagerCancellingInvoice${queryParams || ""}`,undefined, options);
    },
 
    
    complexPackage(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ComplexPackageCounselorOutput >("GET",`${config.apiUrl.store}/StoreQuery/ComplexPackage${queryParams || ""}`,undefined, options);
    },

};